/**
 * One answer to "is this policy current?", for every surface.
 *
 * F1 widened the policy query to include `Expired` rows on purpose: renewals
 * are entered as new rows and the CRM lags, so an Expired row usually means
 * the renewal has not been keyed in yet -- not that the client is uninsured.
 *
 * That makes currency a *presentation* question, and the 2026-08-24 walk
 * showed what happens when each surface answers it differently: an account
 * whose three policies expired in 2009/2010/2017 was shown "3 Active
 * Policies", "Next Renewal: Jan 16, 2009", "All Policies Current", and three
 * proof-of-insurance ID cards with no warning.
 *
 * The expiration date is the thing a client would check, so it is the thing
 * used here.
 */
export const isPolicyCurrent = (policy) => {
  if (!policy) return false;
  const raw = policy.expirationDate || policy.expiration_date;
  if (!raw) return false;
  const expires = new Date(raw);
  if (Number.isNaN(expires.getTime())) return false;
  // Coverage runs to the end of the expiration day.
  expires.setHours(23, 59, 59, 999);
  return expires.getTime() >= Date.now();
};

/** The subset a client is currently covered by. */
export const currentPolicies = (policies) => (policies || []).filter(isPolicyCurrent);
